import { createToken } from '@react-apps/core';
import type { NotifyRepositoryImpl } from '../data/repositories/notify.repository.impl';

export const NotifyRepositoryToken =
  createToken<NotifyRepositoryImpl>('NotifyRepository');
